import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../services/axios';
import { authService } from '../../../../services/auth';

export interface DemandaAutorizacao {
  id: number;
  demanda_fk: number;
  autorizador_fk: number;
  ordem: number | null; // Ordem direta na autorização
  status: 'AGUARDANDO' | 'APROVADO' | 'APROVADA' | 'REPROVADO' | 'REPROVADA';
  comentario?: string;
  created_at: string;
  updated_at: string;
  usuario_fk?: number | null; // Pode ser null quando aguardando
  autorizador: {
    id: number;
    nome_setor: string;
    equipe?: boolean;
    chefe_setor_fk?: number;
    pivot?: {
      id: number;
      processo_fk: number;
      autorizador_fk: number;
      ordem: number | null; // Ordem no pivot (caso venha de processos)
      active: boolean;
      created_at: string;
      updated_at: string;
    };
  };
  usuario_aprovador?: {
    id: number;
    name: string;
  };
}

export interface AutorizacoesResponse {
  autorizacoes: DemandaAutorizacao[];
  is_sequencial: boolean;
}

/**
 * Hook para buscar todas as autorizações de uma demanda
 */
export const useDemandAutorizacoes = (demandaId: number) => {
  return useQuery({
    queryKey: ['demanda-autorizacoes', demandaId],
    queryFn: async (): Promise<AutorizacoesResponse> => {
      await authService.ensureSanctumInitialized();

      const response = await api.post<DemandaAutorizacao[]>(
        `/all/autorizacoes/${demandaId}`
      );

      // Garantir que autorizacoes seja sempre um array
      const autorizacoes = Array.isArray(response.data) ? response.data : [];
      
      // Detectar se é sequencial: se alguma autorização tem ordem !== null
      // Ordem pode vir diretamente no objeto ou em autorizador.pivot.ordem
      const is_sequencial = autorizacoes.length > 0 && autorizacoes.some(
        (aut) => {
          const ordemDireta = aut.ordem !== null && aut.ordem !== undefined;
          const ordemPivot = aut.autorizador?.pivot?.ordem !== null && aut.autorizador?.pivot?.ordem !== undefined;
          return ordemDireta || ordemPivot;
        }
      );

      return {
        autorizacoes,
        is_sequencial,
      };
    },
    enabled: !!demandaId,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};